/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const ResultsPagination = styled.div({
  marginTop: token('space.400'),
  marginBottom: token('space.500'),
  display: 'flex',
  justifyContent: 'center',
});
